import React from 'react';

/**
 * Globální Error Boundary. Zachytí neočekávané výjimky při renderu kdekoliv
 * v aplikaci a místo „bílé obrazovky smrti" zobrazí přívětivý fallback
 * s možností obnovit stránku.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Logujeme do konzole (bez citlivých dat). V produkci sem může jít Sentry apod.
    console.error('Neočekávaná chyba v aplikaci:', error, info?.componentStack);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    if (typeof window !== 'undefined') window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex justify-center items-center min-h-screen bg-neutral-950 p-6">
          <div className="flex flex-col items-center gap-4 text-center max-w-md">
            <div className="text-5xl">🥢</div>
            <h1 className="text-gold-400 font-jost text-2xl font-bold">
              Něco se pokazilo
            </h1>
            <p className="text-neutral-300 text-sm leading-relaxed">
              Omlouváme se, došlo k neočekávané chybě. Zkuste prosím stránku obnovit.
              Pokud potíže přetrvávají, kontaktujte nás na +420&nbsp;725&nbsp;829&nbsp;881.
            </p>
            <button
              onClick={this.handleReload}
              className="mt-2 bg-gold-400 hover:bg-gold-500 text-dark font-jost font-bold px-6 py-3 rounded-lg shadow transition-all"
            >
              Obnovit stránku
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
